import Page from "~/pages/Page";
import { getApi, handleError, logout } from "~/auth";
import * as validation from "~/utils/validation";
import UI from "~/ui";
import { t } from "~/hooks/useI18n";
import $ from "jquery";
import GraficoOfferte from "~/components/GraficoOfferte";
import { gotoLogin, navigateTo } from "~/utils";
import { initializeInputMasks } from "~/input-mask";
import { initTablePlus } from '~/tablePlus';
import getWindowScroll from "@popperjs/core/lib/dom-utils/getWindowScroll";

class AdGestioneOfferte extends Page {

    private theFormOfferta: HTMLFormElement = document.getElementById("form-offerta") as HTMLFormElement;
    private formData: Record<string, string> = {};
    private venditaId: number = 0; // Variabile per memorizzare l'ID della vendita
    private UserId: number = 0; // Aggiungi l'ID dell'utente
    private userInfo: any = null; // Variabile globale per memorizzare le informazioni dell'utente
    private ChartSeries: any = null
    private MaxOfferta: number = 0;
    private MinOfferta: number = 0;
    private MinMedia: number = 0;
    private PrezzoRichiesto: number = 0;
    private TempoRichiesto: number = 0;

    private isSaving: boolean = false; // ✅ flag per tracciare lo stato di salvataggio

    private auth: any = null;

    constructor() {
        super("adgestioneofferte", "AD Gestione Offerte");
    }

    pageStart(): Promise<void> {
        const that = this;
        initializeInputMasks();
        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo"); // Inizializza la variabile globale
        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }
        this.UserId = this.userInfo.anagraficaId; // Inizializza l'ID dell'utente
        $("#UserId").val(this.UserId); // Imposta l'ID dell'utente nel campo nascosto
        this.venditaId = parseInt($("#VenditaId").val() as string) || 0; // Inizializza l'ID della vendita

        initTablePlus();
        this.InitGrafico();

        $("#importoofferto").blur(function (e) {
            const prezzoOfferto: string = $(this).val() as string;
            const offertaMinima: string = $("#offertaMinima").val() as string;
            if (prezzoOfferto) {
                const _prezzoOfferto = parseFloat((prezzoOfferto.replace(/\./g, '')));
                const _offertaMinima = parseFloat((offertaMinima.replace(/\./g, '')));

                if (_prezzoOfferto < _offertaMinima) {
                    UI.confirmOneButton(t("common.atAttention"), t("messages.amountLowerThanMinimum"), "", function (result) {
                        if (result) {
                            $("#importoofferto").val("");
                        }
                    });
                }
            }
        });

        $("#btnManifestazione").on("click", (e) => {
            e.preventDefault();
            that.addValidationForm();
            that.handleFormSubmit(false);
        });

        $("#btnPropostaAcquisto").on("click", (e) => {
            e.preventDefault();
            that.addValidationForm();
            that.handleFormSubmit(true);
        });

        $("#btnFacSimile").on("click", async (e) => {
            e.preventDefault();
            await this.DownloadFacSimilePropostaAcquisto()
        });




        $("#btnSalvaProposta").on("click", (e) => {
            e.preventDefault();
            // ✅ Previeni doppie sottomissioni
            if (this.isSaving) {
                console.warn("Salvataggio già in corso, ignoro il click");
                return;
            }
            that.SalvaProposta();
        });

        $("#btnSalvaManifestazione").on("click", (e) => {
            e.preventDefault();
            // ✅ Previeni doppie sottomissioni
            if (this.isSaving) {
                console.warn("Salvataggio già in corso, ignoro il click");
                return;
            }
            that.SalvaManifestazione();
        });


        $("#btnSimulaSuGrafico").on("click", (e) => {
            e.preventDefault();
            that.addValidationForm();
            that.SimulaSuGrafico();
        });

        $(".btnDeleteManifestazione").on("click", (e) => {
            e.preventDefault();
            const $button = $(e.currentTarget);
            const offertaId = parseInt($button.data("id"), 10);

            if (!offertaId || isNaN(offertaId)) {
                console.error("ID offerta non valido:", $button.data("id"));
                return;
            }

            UI.confirm(t("common.confirm"), t("messages.confirmDeleteManifestazione"), "", async (result) => {
                if (!result) {
                    return;
                }
                await that.DeleteManifestazione(offertaId);
            });
        });

        $("#modalRiepilogoOfferta").on("hidden.bs.modal", function () {
            // Rimuovi manualmente il backdrop se rimane
            $(".modal-backdrop").remove();
            $("body").removeClass("modal-open").css("overflow", "");
            $("body").css("padding-right", "");
        });


        return Promise.resolve();
    }


    private addValidationForm(): void {
        const that = this;
        const form = this.theFormOfferta;

        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        const inputValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const inputValue = $(inputElement).val() as string;
            const isValid = inputValue.length > 0;

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.required")
            };
        }

        // ✅ Validatore per i radio button con casting corretto
        const inputRadioValidator = (name: string): validation.ValidationResult => {
            const $radios = $(`input[name='${name}']`);
            const isChecked = $radios.is(":checked");

            $radios.each((index, element) => {
                const input = element as HTMLInputElement;
                if (!isChecked) {
                    input.setCustomValidity(t("validation.selectOption"));
                    $(input).addClass("is-invalid").removeClass("is-valid");
                } else {
                    input.setCustomValidity("");
                    $(input).removeClass("is-invalid").addClass("is-valid");
                }
            });

            return {
                ok: isChecked,
                error: isChecked ? "" : t("validation.selectOption")
            };
        };

        validation.setValidatorOnInput("importoofferto", inputValidator);
        validation.setValidatorOnInput("accontorogito", inputValidator);
        validation.setValidatorOnInput("temporogito", inputValidator);

        // Event listener
        $("input[name='SubordinataVenditaCasa']").on("change", () => {
            $("input[name='SubordinataVenditaCasa']").each((index, element) => {
                const input = element as HTMLInputElement;
                input.setCustomValidity("");
                $(input).removeClass("is-invalid").addClass("is-valid");
            });
        });

        // Event listener
        $("input[name='SubordinataApprovazioneMutuo']").on("change", () => {
            $("input[name='SubordinataApprovazioneMutuo']").each((index, element) => {
                const input = element as HTMLInputElement;
                input.setCustomValidity("");
                $(input).removeClass("is-invalid").addClass("is-valid");
            });
        });

        this.onSubmitValidator = () => {
            validation.validate("importoofferto", inputValidator);
            validation.validate("accontorogito", inputValidator);
            validation.validate("temporogito", inputValidator);
            inputRadioValidator("SubordinataVenditaCasa");
            inputRadioValidator("SubordinataApprovazioneMutuo");
        };
    }

    private async handleFormSubmit(isPropostaAcquisto: boolean): Promise<void> {
        // Validazione del form
        this.onSubmitValidator();

        if (!this.theFormOfferta.checkValidity()) {
            this.theFormOfferta.classList.add('was-validated');
            return;
        }

        // ✅ Serializza i dati
        this.formData = {}; // ✅ Resetta formData prima di serializzare
        $("#form-offerta")
            .serializeArray()
            .forEach((field) => {
                this.formData[field.name] = field.value;
            });

        var prezzoOfferto: string = this.formData["PrezzoOfferto"] as string;
        this.formData["PrezzoOfferto"] = prezzoOfferto.replace(/\./g, '');
        var importoAlCompromesso: string = this.formData["ImportoAlCompromesso"] as string;
        this.formData["ImportoAlCompromesso"] = importoAlCompromesso.replace(/\./g, '');

        console.log(this.formData);

        let _ = this.spinner.spin();
        try {
            // ✅ Controllo se l'offerta è migliorativa SOLO DOPO validazione
            if (isPropostaAcquisto) {
                const url = window.BaseUrlWebApi + "AstaDinamica/IsOffertaMigliorativa";
                const result = await this.auth.fetchWithAuth("POST " + url, {
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(this.formData),
                });

                console.info(result);
                if (!result.IsOffertaPrecedenteCauzionata && result.IsOffertaUguale) {
                    //Siamo nel caso in cui la manifestazione precedente è uguale all'offerta che vogliamo cauzionare
                    //in questo caso visualizziamo la modale con il pulsante invia proposta

                    const btnInvioProposta = `<a href="/proposta-acquisto-asta-dinamica-${result.IdOffertaPrecedente}" class="btn btn-success">
                                                    ${t("offerta.sendProposta")}
                                              </a>`;
                    $("#btnInvioProposta").html(btnInvioProposta);
                    $("#modal-cauziona-offerta-precedente").modal("show");
                } else if (!result.IsOffertaMigliorativa && result.IsOffertaPrecedenteCauzionata) {

                    UI.confirmOneButton("",
                        `${t("messages.offerImprovementCriteria")}`,
                        "modal-lg");
                    return;
                } else {
                    // ✅ Se tutto è valido, mostra il riepilogo
                    if (this.SetModaleRiepilogo(isPropostaAcquisto)) {
                        $("#modalRiepilogoOfferta").modal("show");
                    }
                }
            } else {
                // ✅ Controllo se esiste già una manifestazione uguale
                const url = window.BaseUrlWebApi + "AstaDinamica/ExistManifestazioneUguale";
                const result = await this.auth.fetchWithAuth("POST " + url, {
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(this.formData),
                });

                if (result.OffertaUguale) {
                    UI.confirmOneButton(t("common.attention"),
                        t("messages.identicalOfferExists"),
                        "");
                    return;
                } else {
                    // ✅ Se tutto è valido, mostra il riepilogo
                    if (this.SetModaleRiepilogo(isPropostaAcquisto)) {
                        $("#modalRiepilogoOfferta").modal("show");
                    }
                }

            }



        } catch (e) {
            console.info(e);
            UI.confirmOneButton("", t("messages.errorSubmittingOffer"));
        } finally {
            this.spinner.stop();
        }
    }

    private onSubmitValidator: () => void = async () => {
    }

    private SetModaleRiepilogo(isPropostaAcquisto: boolean): boolean {
        // Imposta i valori nei campi della modale di riepilogo
        const prezzoOfferto = this.formData["PrezzoOfferto"].replace(/\./g, '').split(".")[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + " €";
        const importoAlCompromesso = this.formData["ImportoAlCompromesso"].replace(/\./g, '').split(".")[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + " €";
        const periodoRogito = parseInt(this.formData["PeriodoRogito"]) * 3; // Moltiplica per 3 per ottenere i mesi
        const subordinataVendita = this.formData["SubordinataVenditaCasa"] === "true" ? t("common.yes") : t("common.no");
        const subordinataMutuo = this.formData["SubordinataApprovazioneMutuo"] === "true" ? t("common.yes") : t("common.no");
        const note = this.formData["Note"] || "Nessuna nota";

        $(".importoOfferto").text(prezzoOfferto);
        $(".importoCompromesso").text(importoAlCompromesso);
        $(".periodoRogito").text(periodoRogito + " " + t("common.months"));
        $(".subordinatoVendita").text(subordinataVendita);
        $(".subordinatoMutuo").text(subordinataMutuo);
        $(".note").html(note);
        if (isPropostaAcquisto) {
            $("#modalRiepilogoOfferta").find(".modal-title").text(t("offerta.proposalOfPurchase"));
            $("#alertMessage").html(t("messages.verifyDataBeforeProceed"));
            $("#btnSalvaManifestazione").addClass("d-none");
            $("#btnSalvaProposta").removeClass("d-none");
            if ($("#PossibileRilancio").val() == "true") {
                $("#alertPossibileRilancio").removeClass("d-none");
            } else {
                $("#alertPossibileRilancio").addClass("d-none");
            }
        } else {
            $("#modalRiepilogoOfferta").find(".modal-title").html(t("messages.manifestationOfInterest"));
            $("#alertMessage").html(t("messages.verifyDataBeforeConfirm"));
            $("#btnSalvaProposta").addClass("d-none");
            $("#btnSalvaManifestazione").removeClass("d-none");
            $("#alertPossibileRilancio").addClass("d-none");
        }

        return true;
    }

    private async SalvaManifestazione(): Promise<void> {
        const that = this;
        // ✅ Imposta la flag e disabilita il pulsante
        this.isSaving = true;
        const $btnSalva = $("#btnSalvaManifestazione");
        $btnSalva.prop("disabled", true);

        //nascondo modalRiepilogoOfferta
        $("#modalRiepilogoOfferta").modal("hide");
        await this.ResetModaleRipilogoOfferta();
        let _ = this.spinner.spin();
        try {
            const url = window.BaseUrlWebApi + "AstaDinamica/SalvaManifestazione";
            await this.auth.fetchWithAuth("POST " + url, {
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(this.formData),
            });


            // Resetta il form
            this.theFormOfferta.reset();
            this.theFormOfferta.classList.remove("was-validated");
            // Rimuove gli stati di errore dai campi
            $(this.theFormOfferta).find("input, textarea").each(function () {
                $(this).removeClass("is-invalid is-valid");
            });

            UI.confirmOneButton(t("common.congratulations"), t("messages.manifestazioneSuccess"), "", function (result) {
                if (result) {
                    // Se l'utente ha confermato, reindirizza alla pagina di gestione dell'offerta
                    if (that.venditaId > 0) {
                        navigateTo(window.BaseUrlWeb + "offerta-asta-dinamica-" + that.venditaId);
                    }
                }
            });


        } catch (e) {
            console.info(e);
            UI.confirmOneButton("", t("messages.errorSaving")); //TODO: i18n
        } finally {
            // ✅ Ripristina sempre lo stato (anche in caso di errore)
            this.isSaving = false;
            $btnSalva.prop("disabled", false);
            this.spinner.stop();
        }
    }

    private async SalvaProposta(): Promise<void> {
        const that = this;
        // ✅ Imposta la flag e disabilita il pulsante
        this.isSaving = true;
        const $btnSalva = $("#btnSalvaProposta");
        $btnSalva.prop("disabled", true);

        //nascondo modalRiepilogoOfferta
        $("#modalRiepilogoOfferta").modal("hide");
        await this.ResetModaleRipilogoOfferta();
        let _ = this.spinner.spin();
        try {
            const url = window.BaseUrlWebApi + "AstaDinamica/SalvaPropostaAcquisto";
            const offertaId: number = await this.auth.fetchWithAuth("POST " + url, {
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(this.formData)
            });

            // Resetta il form
            this.theFormOfferta.reset();
            this.theFormOfferta.classList.remove("was-validated");
            // Rimuove gli stati di errore dai campi
            $(this.theFormOfferta).find("input, textarea").each(function () {
                $(this).removeClass("is-invalid is-valid");
            });

            navigateTo(window.BaseUrlWeb + "proposta-acquisto-asta-dinamica-" + offertaId);

        } catch (e) {
            console.info(e);
            UI.confirmOneButton("", t("messages.errorSaving")); //TODO: i18n
        } finally {
            // ✅ Ripristina sempre lo stato (anche in caso di errore)
            this.isSaving = false;
            $btnSalva.prop("disabled", false);
            this.spinner.stop();
        }
    }

    private async ResetModaleRipilogoOfferta(): Promise<void> {
        // Resetta i campi della modale di riepilogo
        $(".importoOfferto").text("");
        $(".importoCompromesso").text("");
        $(".periodoRogito").text("");
        $(".subordinatoVendita").text("");
        $(".subordinatoMutuo").text("");
        $(".note").text("");
    }

    private async InitGrafico() {
        const that = this;
        const chartData: any = (window as any).chartData;
        // ID del contenitore HTML dove verrà renderizzato il grafico
        const containerId = "chartdiv";
        // Inizializza le variabili con i dati recuperati
        this.ChartSeries = chartData.chartSeries;
        this.MaxOfferta = chartData.maxOfferta;
        this.MinOfferta = chartData.minOfferta;
        this.MinMedia = chartData.minMedia;
        this.PrezzoRichiesto = chartData.prezzoRichiesto;
        this.TempoRichiesto = chartData.tempoRichiesto;

        const grafico = new GraficoOfferte(
            containerId,
            this.PrezzoRichiesto,
            this.TempoRichiesto,
            this.MaxOfferta,
            this.MinOfferta,
            this.MinMedia,
            this.ChartSeries
        );

        // Inizializzazione del grafico
        grafico.initGrafico(this.PrezzoRichiesto, this.TempoRichiesto, this.MaxOfferta, this.MinOfferta, this.MinMedia, this.ChartSeries);
    }

    private async SimulaSuGrafico(): Promise<void> {
        // Validazione del form
        this.onSubmitValidator();
        if (!this.theFormOfferta.checkValidity()) {
            this.theFormOfferta.classList.add('was-validated');
            return;
        }

        $("#form-offerta")
            .serializeArray()
            .forEach((field) => {
                this.formData[field.name] = field.value;
            });

        var prezzoOfferto: string = this.formData["PrezzoOfferto"] as string;
        this.formData["PrezzoOfferto"] = prezzoOfferto.replace(/\./g, '');
        var importoAlCompromesso: string = this.formData["ImportoAlCompromesso"] as string;
        this.formData["ImportoAlCompromesso"] = importoAlCompromesso.replace(/\./g, '');

        console.log(this.formData);

        let _ = this.spinner.spin();
        try {
            let result: any = await this.SimulaOfferta();

            if (!result) {
                UI.confirmOneButton("", t("messages.errorDuringSimulation"));
                return;
            }

            const chartData: any = (window as any).chartData;
            // ID del contenitore HTML dove verrà renderizzato il grafico
            const containerId = "chartdiv";
            // Inizializza le variabili con i dati recuperati
            this.ChartSeries = result["ChartSeries"] as any;
            this.MaxOfferta = result["MaxOfferta"] as number;
            this.MinOfferta = result["MinOfferta"] as number;
            this.MinMedia = result["MinMedia"] as number;
            this.PrezzoRichiesto = result["PrezzoRichiesto"] as number;
            this.TempoRichiesto = result["TempoRichiesto"] as number;

            const grafico = new GraficoOfferte(
                containerId,
                this.PrezzoRichiesto,
                this.TempoRichiesto,
                this.MaxOfferta,
                this.MinOfferta,
                this.MinMedia,
                this.ChartSeries
            );

            // Inizializzazione del grafico
            grafico.initGrafico(this.PrezzoRichiesto, this.TempoRichiesto, this.MaxOfferta, this.MinOfferta, this.MinMedia, this.ChartSeries);

            // ✅ Attiva il tab "grafico-tab"
            const graficoTab = document.getElementById("grafico-tab");
            if (graficoTab) {
                // Metodo 1: Usa Bootstrap Tab API (jQuery)
                ($('#grafico-tab') as any).tab('show');

                // Oppure Metodo 2: Simula un click (alternativa)
                // graficoTab.click();
            }

            // Dopo aver attivato il tab, scorri al div desiderato
            const andamentoDiv = document.getElementById("andamentoOfferte");
            if (andamentoDiv) {
                // ✅ Aggiungi un piccolo delay per permettere al tab di aprirsi prima dello scroll
                setTimeout(() => {
                    andamentoDiv.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 300);
            }


        } catch (e) {
            console.info(e);
            UI.confirmOneButton("", t("messages.errorDuringSimulation")); //TODO: i18n
        } finally {
            this.spinner.stop();
        }
    }

    private async SimulaOfferta(): Promise<any> {

        const url = window.BaseUrlWebApi + "AstaDinamica/SimulaOfferta";
        const result = await this.auth.fetchWithAuth("POST " + url, {
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(this.formData),
        });

        return result;

    }

    private async DeleteManifestazione(offertaId: number): Promise<void> {
        let _ = this.spinner.spin();
        try {
            const url = window.BaseUrlWebApi + "AstaDinamica/DeleteOffertaById?offertaId=" + offertaId;

            const result = await this.auth.fetchWithAuth("DELETE " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            console.log("Offerta cancellata con successo.");

            // ✅ Rimuovi righe con ID univoci
            this.rimuoviRigaTabella(`#row-elenco-${offertaId}`);    // Tabella Elenco
            this.rimuoviRigaTabella(`#row-andamento-${offertaId}`); // Tabella Andamento


            // ✅ Rimuovi immediatamente la riga e quella dei dettagli
            $(`#row${offertaId}`).remove();
            $(`#row${offertaId}`).next('.expand-row-details').remove();

            // ✅ Aggiorna i numeri progressivi
            this.aggiornaNumeriOfferte();

            // ✅ Gestisci tabelle vuote
            this.gestisciTabellaVuota("#table-offerte", 12);
            this.gestisciTabellaVuota("#table-andamento-offerte", 7);

            // ✅ Mostra messaggio di successo
            UI.confirmOneButton("", t("messages.manifestazioneDeleted"), "");

        } catch (error) {
            console.error("Errore durante la cancellazione dell'offerta:", error);
            UI.confirmOneButton("", t("messages.errorDeletingOffer"));
        } finally {
            this.spinner.stop();
        }
    }

    /**
     * ✅ Aggiorna i numeri progressivi delle offerte dopo una cancellazione
     */
    private aggiornaNumeriOfferte(): void {
        const $rows = $("#table-offerte tbody tr:not(.expand-row-details)");
        let numeroProgressivo = $rows.length;

        $rows.each(function () {
            const $numberCell = $(this).find('th:first span.fs-4.fw-bold');
            if ($numberCell.length > 0) {
                $numberCell.html(`<span class="fw-normal">#</span>${numeroProgressivo}`);
                numeroProgressivo--;
            }
        });
    }

    /**
 * ✅ Rimuove una riga e la sua riga di dettagli espandibili
 */
    private rimuoviRigaTabella(rowSelector: string): void {
        const $row = $(rowSelector);
        const $expandRow = $row.next('.expand-row-details');

        $row.remove();
        if ($expandRow.length > 0) {
            $expandRow.remove();
        }
    }

    /**
     * ✅ Gestisce il messaggio per tabelle vuote
     */
    private gestisciTabellaVuota(tableSelector: string, colspan: number): void {
        const remainingRows = $(`${tableSelector} tbody tr:not(.expand-row-details)`).length;

        if (remainingRows === 0) {
            $(`${tableSelector} tbody`).html(`
            <tr>
                <td colspan="${colspan}" class="text-center">
                    <span class="text-secondary">${t("messages.noOffersPresent")}</span>
                </td>
            </tr>
        `);
        }
    }

    private async DownloadFacSimilePropostaAcquisto(): Promise<void> {
        this.spinner.spin();
        const url = window.BaseUrlWebApi + "AstaDinamica/GetFacSimilePropostaAcquisto?venditaId=" + this.venditaId + "&userId=" + this.UserId;
        try {
            const response = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { "Content-Type": "application/json" },
            });

            if (!response) {
                throw new Error(t("messages.errorGeneratingPDF"));
            }

            const blob = await response;
            const downloadUrl = window.URL.createObjectURL(blob);

            // const a = document.createElement("a");
            // a.href = downloadUrl;
            // a.download = "FacSimile-PropostaDiAcquisto.pdf";
            // document.body.appendChild(a);
            // a.click();
            // a.remove();
            // window.URL.revokeObjectURL(downloadUrl);


            // Apri il PDF in una nuova scheda invece di scaricarlo
            window.open(downloadUrl, "_blank");

            // Revoca l'URL dopo un breve delay per permettere l'apertura
            setTimeout(() => {
                window.URL.revokeObjectURL(downloadUrl);
            }, 1000);

        } catch (error) {
            console.error("Errore durante il download del fac-simile:", error);
            UI.confirmOneButton("", "Errore durante il download del documento.");
        } finally {
            this.spinner.stop();
        }
    }

}

export default AdGestioneOfferte;

